var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeightFacility(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.623,
    height: 34.738,
    viewBox: "0 0 39.623 34.738",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.647,33.738c-1.185,0-2.363,0-3.515,0l-.081,0c-1.08,0-2.141,0-3.167,0H1.329a1.32,1.32,0,0,1-1.054-.519,1.306,1.306,0,0,1-.225-1.159L6.16,9.267A1.332,1.332,0,0,1,7.438,8.28l.643,0h.205c.739,0,1.661-.011,2.749-.015l.391,0c.856,0,1.781,0,2.76-.008l.174,0h.181l1.973-.01A4.641,4.641,0,1,1,22.4,8.213l.71,0c2.244,0,4.224-.01,5.748-.01,1.216,0,2.1,0,2.465.015a1.421,1.421,0,0,1,1.34,1.058c1.917,7.217,3.957,14.946,5.9,22.578a1.5,1.5,0,0,1-.267,1.288,1.519,1.519,0,0,1-1.187.591c-1.006,0-2.213,0-3.571,0l-3.125,0C26.888,33.735,22.819,33.738,18.647,33.738Zm16.026-8.553a.752.752,0,0,0-.14.016.634.634,0,0,0-.467.754L34.543,28a.621.621,0,0,0,.606.487.761.761,0,0,0,.143-.015.63.63,0,0,0,.467-.752l-.472-2.052A.63.63,0,0,0,34.673,25.185ZM31.548,10.97a.5.5,0,0,0-.143.018.6.6,0,0,0-.391.277.623.623,0,0,0-.077.472L33.294,21.9a.623.623,0,0,0,.611.482.722.722,0,0,0,.143-.013.632.632,0,0,0,.467-.751L32.159,11.452A.631.631,0,0,0,31.548,10.97ZM19.444,1.4a3.244,3.244,0,1,0,3.244,3.244A3.246,3.246,0,0,0,19.444,1.4Z",
    transform: "translate(0.506 0.5)",
    fill: "#acffe1",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeightFacility);
export default __webpack_public_path__ + "static/media/weightFacility.c930ae8671c04dada03476277c615d09.svg";
export { ForwardRef as ReactComponent };